import axios from "axios";
import React, { useState, useEffect, Fragment } from "react";
import { Link, useHistory } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Button, Dropdown } from "react-bootstrap";
import "../table/FilteringTable/filtering.css";

import Select from "react-select";
import { Form, Row, Col } from "react-bootstrap";
import { API_URL } from "../../../config";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logout } from "../../../store/actions/AuthActions";
import { setCourses } from "../../../store/actions/CourseAction";
const OfferTable = () => {
  const collegeId = useSelector((state) => state.college_id.college_id);
  const courses = useSelector((state) => state.courses.courses);
  const [offers, setOffers] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const [packageValue, setPackageValue] = useState("");
  const [companyId, setCompanyId] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [position, setPosition] = useState("");
  const [acceptance, setAcceptance] = useState(1);
  const [jobid, setjobId] = useState(null);
  const [dateOffered, setDateOffered] = useState("");
  const [joiningDate, setJoiningDate] = useState("");
  const [studentEmail, setStudentEmail] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isEditing, setEditing] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [offerId, setOfferId] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const dispatch = useDispatch();
  //search job and student
  const [searchJobQuery, setSearchJobQuery] = useState("");
  const [searchStudentQuery, setSearchStudentQuery] = useState("");
  const [searchjobslist, setSearchjobslist] = useState([]);
  const [searchstudentlist, setSearchstudentlist] = useState([]);
  const [jobOptions, setJobOptions] = useState([]);
  const [studentOptions, setStudentOptions] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentId, setStudentId] = useState(null);
  const [educationdetails, setEducationDetails] = useState([]);
  const [isotherJobRole, setisOtherJobRole] = useState(false);
  const [otherJobRole, setOtherJobRole] = useState(null);
  const [position_id, setPositionId] = useState(null);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [course, setCourse] = useState(null);
  const [specializationId, setSpecializationId] = useState(null);
  const [specializationData, setSpecializationData] = useState([]);
  const [specializationName, setSpecializationName] = useState(
    "Choose Specialization",
  );
  const [passoutYear, setPassoutYear] = useState("Passout Year");
  const [coursefilterId, setCourseFilterId] = useState(null);
  const [search, setSearch] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const currentYear = new Date().getFullYear();

  // Fetch all data from API
  const fetchOffers = async () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    setIsLoading(true); // Start loading
    try {
      const params = {
        college_id: collegeId,
        offset: currentPage * itemsPerPage,
        limit: itemsPerPage,
      };

      if (course !== null) {
        params.filter_by_course = course.filter_id;
      }

      if (
        specializationId !== null &&
        specializationName !== "Choose Specialization"
      ) {
        params.filter_by_specialization = specializationId;
      }

      if (passoutYear !== "Passout Year") {
        params.filter_by_passout_year = passoutYear;
      }

      if (search !== "") {
        params.search = search;
      }

      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/JobOffer/get_job_offer_list`,
        {
          params,
          headers: {
            Authorization: authToken,
          },
        },
      );

      const { data, totalRecords } = response.data;
      setOffers(data);
      setTotalRecords(totalRecords);
    } catch (error) {
      if (error?.response?.status === 401) {
        dispatch(logout());
      }
      console.error("Error fetching offers:", error);
      setOffers([]); // Set empty array on error to prevent issues
    } finally {
      setIsLoading(false);
    }
  };

  // Load specialization data when course changes
  useEffect(() => {
    if (course !== null) {
      const fetchSpecializations = async () => {
        const payload = {
          college_id: collegeId,
          course_id: course.college_course_id,
        };
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const authToken = userDetails?.data?.auth_token;

        try {
          const response = await axios.get(
            `${API_URL}/api/freshment_portal_apis/GenericAPI/get_course_spealization_list`,
            {
              params: payload,
              headers: {
                Authorization: authToken,
              },
            },
          );
          setSpecializationData(response.data.data);
        } catch (err) {
          if (err?.response?.status === 401) {
            dispatch(logout());
          }
          console.log("Error fetching specializations:", err);
        }
      };

      fetchSpecializations();
    } else {
      setSpecializationData([]);
    }
  }, [course]);

  // Handle search button click
  const handleReset = () => {
    setCourse(null);
    setSpecializationId(null);
    setSpecializationName("Choose Specialization");
    setPassoutYear("Passout Year");
    setSearch("");
    setCurrentPage(0);
  };

  // Handle pagination click
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 0 && pageNumber < totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  const handleAddOffer = async () => {
    const offerData = {
      package: packageValue,
      company_id: companyId,
      position_id,
      acceptance,
      date_offered: dateOffered,
      joining_date: joiningDate,
      student_id: studentId,
      other_company_name: companyName,
      other_company_email: companyEmail,
      other_company_address: companyAddress,
      offer_id: offerId,
      job_id: jobid,
      other_position: otherJobRole,
    };

    // if (
    //   offerData.position_id == "Select Job Role" ||
    //   offerData.position_id == "" ||
    //   offerData.position_id == null
    // ) {
    //   toast.error("Please enter position_id")
    //   return;
    // }
    if (offerData.date_offered == null || offerData.date_offered == "") {
      toast.error("Please enter date offered.");
      return;
    }

    // if (
    //   offerData.position_id == null ||
    //   offerData.position_id == undefined ||
    //   offerData.position_id == "" ||
    //   typeof offerData.position_id == "number"
    // ) {
    //   toast.error("Please enter valid position_id.")
    //   return;
    // }
    const params = new URLSearchParams();
    if (isEditing) {
      // params.append("college_id", 1);
      params.append("package", offerData.package);
      params.append("job_id", offerData.job_id);
      if (offerData.other_position != null && offerData.position_id == null) {
        params.append("other_position", offerData.other_position);
      } else {
        params.append("job_role_id", offerData.position_id);
      }
      params.append("acceptance", offerData.acceptance);
      params.append("date_offered", offerData.date_offered);
      params.append("joining_date", offerData.joining_date);
      params.append("offer_id", offerData.offer_id);
      // params.append("student_email", offerData.student_email);
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      // console.log(params);
      await axios
        .post(
          `${API_URL}/api/freshment_portal_apis/PlaceOffer/update_job_placement_offer`,
          params,
          {
            headers: {
              Authorization: authToken,
              "Content-Type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          },
        )
        .then((response) => {
          // console.log(response);
          if (response.data.success) {
            toast.success(
              "The job placement offer has been Updated successfully.",
            );
            resetFormFields();
            setEditing(false);
            fetchOffers();
          } else {
            toast.error(
              response.data.message ||
                "There was an error Updating the offer. Please try again.",
            );
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            dispatch(logout());
          }
          toast.error(
            "There was an error Updating the offer. Please try again.",
          );
        });
    } else {
      params.append("college_id", collegeId);
      params.append("package", offerData.package);
      params.append("job_id", offerData.job_id);
      if (offerData.position_id == null) {
        params.append("other_position", offerData.other_position);
      } else {
        params.append("job_role_id", offerData.position_id);
      }
      params.append("acceptance", offerData.acceptance);
      params.append("date_offered", offerData.date_offered);
      params.append("joining_date", offerData.joining_date);
      params.append("student_id", offerData.student_id);
      if (
        offerData.company_id == null ||
        offerData.company_id == undefined ||
        offerData.company_id == ""
      ) {
        params.append("other_company_name", offerData.other_company_name);
        params.append("other_company_email", offerData.other_company_email);
        params.append("other_company_address", offerData.other_company_address);
      } else {
        params.append("company_id", offerData.company_id);
      }
      // console.log(params);
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      await axios
        .post(
          `${API_URL}/api/freshment_portal_apis/PlaceOffer/save_job_placement_offer`,
          params,
          {
            headers: {
              Authorization: authToken,
            },
          },
        )
        .then((response) => {
          // console.log(response);
          if (response.data.success) {
            toast.success(
              "The job placement offer has been added successfully.",
            );
            resetFormFields();
            fetchOffers();
          } else {
            toast.error(
              response.data.message ||
                "There was an error adding the offer. Please try again.",
            );
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            dispatch(logout());
          }
          toast.error("There was an error adding the offer. Please try again.");
        });
    }
  };

  // useEffect(() => {
  //   console.log(selectedStudentId);
  // }, [selectedStudentId]);
  //handle edit
  const handleEdit = async (id, stud_id) => {
    const payload = { offer_id: id };
    // console.log(id, payload);
    const studId = { student_id: stud_id };
    setOfferId(id);
    // Reset states before loading new data
    setSelectedCompany(null);
    setSearchQuery("");
    setSearchJobQuery("");
    setSearchStudentQuery("");
    // Set editing state
    setEditing(true);
    // console.log(studId);
    try {
      // Send a request to the API to get job offer details
      const params = new URLSearchParams();
      params.append("offer_id", payload.offer_id);
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      const response = await axios.post(
        `${API_URL}/api/freshment_portal_apis/PlaceOffer/get_job_offer_detail`,
        params,
        {
          headers: {
            Authorization: authToken,
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        },
      );

      const offer = response.data.data;

      // Update state with offer details
      // setSearchQuery(offer.company_name);
      setPackageValue(offer.package);
      setCompanyId(offer.company_id);
      setPosition(offer.position);
      setPositionId(offer.job_role_id);
      setAcceptance(offer.acceptance);
      setDateOffered(offer.date_offered);
      setJoiningDate(offer.joining_date);
      setStudentEmail(offer.email);
      setCompanyName(offer.company_name);
      setCompanyAddress(offer.company_address || ""); // Use empty string if company_address is null
      setCompanyEmail(offer.company_email);
      setjobId(offer.job_id);
      // console.log(offer.full_name, studId.student_id);

      // Fetch company options based on company name
      const fetchCompaniesData = async (
        company_id,
        company_name,
        company_address,
        company_email,
      ) => {
        const options = [
          { value: null, label: "Enter company name" },
          {
            value: company_id,
            label: company_name,
            company_address: company_address,
            company_email: company_email,
            company_id: company_id,
          },
        ];

        setCompanyOptions(options);

        // Set selected company if it matches the offer's company ID
        const selectoption = options.find(
          (option) => option.company_id === company_id,
        );

        // Ensure that selected company is only set once options are available
        setSelectedCompany(selectoption); // Ensure null if no match
      };

      const fetchJobsData = async (position, position_id) => {
        // Initialize options as an array
        const options = [
          {
            value: null,
            label: "Add Other Job Role",
          },
          {
            value: position_id,
            label: position,
          },
        ];

        // Set company options
        setJobOptions(options);
        // console.log(options, position_id);

        const selectOption = options.find(
          (option) => option.value === position_id,
        );
        // console.log(selectOption);

        setSelectedJob(selectOption); // Ensure null if no match
      };

      const fetStudentsData = async (Student, email, id) => {
        const options = [
          {
            value: null,
            label: "Search Student",
          },
          {
            value: email,
            label: Student,
            student_id: id,
            // education_details: student.education_details,
          },
        ];

        setStudentOptions(options);
        const selectoption = options.find((option) => option.student_id === id);
        setSelectedStudent(selectoption); // Ensure null if no match
      };
      await fetStudentsData(offer.full_name, offer.email, studId.student_id);
      await fetchJobsData(offer.position, offer.job_role_id);
      await fetchCompaniesData(
        offer.company_id,
        offer.company_name,
        offer.company_address,
        offer.company_email,
      );
    } catch (error) {
      if (error?.response?.status === 401) {
        dispatch(logout());
      }
      console.error("Error fetching job offer details:", error);
    }
  };

  const resetFormFields = () => {
    setPackageValue("");
    setCompanyName("");
    setCompanyAddress("");
    setCompanyEmail("");
    setPosition("");
    setAcceptance(1);
    setDateOffered("");
    setJoiningDate("");
    setStudentEmail("");
    setSelectedCompany(null);
    setCompanyId(null);
    setOfferId(null);
    setjobId(null);
    setSearchQuery("");
    setSearchJobQuery("");
    setSearchStudentQuery("");
    setSelectedJob(null);
    setSelectedStudent(null);
    setisOtherJobRole(false);
    setOtherJobRole(null);
    setPositionId(null);
    setOfferId(null);
    setStudentId(null);
    setStudentEmail("");
    setSelectedJob(null);
    setSelectedCompany(null);
    setCompanyId(null);
    setjobId(null);
    setSelectedStudentId(null);
    setJobOptions([{ value: null, label: "Add Other Job Role" }]);
    setCompanyOptions([{ value: null, label: "Enter company name" }]);
    setStudentOptions([{ value: null, label: "Search Student" }]);
  };

  // useEffect(() => {
  //   console.log(selectedCompany);
  // }, [selectedCompany]);

  // Delete Offer Handler with Confirmation
  const handleDelete = async (props) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",

      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-primary btn-sm",
        cancelButton: "btn btn-danger btn-sm ms-2",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = new URLSearchParams();
        params.append("offer_id", props.job_offer_id);
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const authToken = userDetails?.data?.auth_token;

        try {
          const response = await axios.post(
            `${API_URL}/api/freshment_portal_apis/PlaceOffer/delete_job_placement_offer`,
            params, // Pass the encoded params
            {
              headers: {
                Authorization: authToken,
                "Content-Type":
                  "application/x-www-form-urlencoded; charset=UTF-8",
              },
            },
          );
          // console.log(response);
          if (response.data.success) {
            toast.success("Your offer has been deleted.");
            // Refresh the offers list after deletion
            const updatedOffers = offers.filter(
              (offer) => offer?.job_offer_id !== props.job_offer_id,
            );
            setOffers(updatedOffers);
          } else {
            toast.error(response.data.message || "Failed to delete offer.");
          }
        } catch (error) {
          if (error?.response?.status === 401) {
            dispatch(logout());
          }
          console.error("Error deleting offer:", error);
          toast.error("An error occurred while deleting the offer.");
        }
      }
    });
  };

  useEffect(() => {
    // console.log(searchQuery.length);
    if (searchQuery != "" && searchQuery.length >= 2) {
      const fetchCompanies = async () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const authToken = userDetails?.data?.auth_token;

        try {
          const response = await axios.get(
            `${API_URL}/api/freshment_portal_apis/GenericAPI/get_company_list`,
            {
              params: { search: searchQuery },
              headers: {
                Authorization: authToken,
              },
            },
          );
          const data = response.data.data;
          // console.log(data);
          const options = data.map((company) => ({
            value: company.company_id,
            label: company.company_name,
            company_address: company.company_address,
            company_email: company.company_email,
            company_id: company.company_id,
          }));
          options.unshift({
            value: null,
            label: "Enter company name",
          });
          setCompanyOptions(options);
        } catch (error) {
          if (error?.response?.status === 401) {
            dispatch(logout());
          }
          console.error("Error fetching companies:", error);
        }
      };
      fetchCompanies();
    } else if (
      searchQuery == "" ||
      searchQuery == null ||
      searchQuery.length < 2
    ) {
      const options = [
        {
          value: null,
          label: "Enter company name",
        },
      ];
      setCompanyOptions(options);
    }
  }, [searchQuery]);

  useEffect(() => {
    // console.log(searchJobQuery.length);
    if (searchJobQuery != "" && searchJobQuery.length >= 2) {
      const fetchJobslistDropdown = async () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const authToken = userDetails?.data?.auth_token;

        try {
          const response = await axios.get(
            `${API_URL}/api/freshment_portal_apis/students/search_job_roles`,
            {
              params: { search: searchJobQuery, college_id: collegeId },
              headers: {
                Authorization: authToken,
              },
            },
          );
          const data = response.data.data;
          // console.log(data);
          const optionsjob = data.map((job) => ({
            value: job.id,
            label: job.job_role_name,
          }));
          optionsjob.unshift({
            value: null,
            label: "Add Other Job Role",
          });
          setJobOptions(optionsjob);
        } catch (error) {
          if (error?.response?.status === 401) {
            dispatch(logout());
          }
          console.error("Error fetching jobs:", error);
        }
      };
      fetchJobslistDropdown();
    } else if (
      searchJobQuery == "" ||
      searchJobQuery == null ||
      searchJobQuery.length < 2
    ) {
      const optionsjob = [
        {
          value: "Add Other Job Role",
          label: "Add Other Job Role",
        },
      ];
      setJobOptions(optionsjob);
    }
  }, [searchJobQuery]);

  useEffect(() => {
    // console.log(searchStudentQuery.length);
    if (searchStudentQuery != "" && searchStudentQuery.length >= 2) {
      const fetchStudentListDropdown = async () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const authToken = userDetails?.data?.auth_token;

        try {
          const response = await axios.get(
            `${API_URL}/api/freshment_portal_apis/students/search_student_list`,
            {
              params: { search: searchStudentQuery, college_id: collegeId },
              headers: {
                Authorization: authToken,
              },
            },
          );
          const data = response.data.data;
          // console.log(data);
          const optionsStudent = data.map((student) => ({
            value: student.email,
            label: student.full_name,
            student_id: student.onboarding_student_id,
            education_details: student.education_details,
          }));
          optionsStudent.unshift({
            value: null,
            label: "Search Student",
          });
          setStudentOptions(optionsStudent);
        } catch (error) {
          if (error?.response?.status === 401) {
            dispatch(logout());
          }
          console.error("Error fetching students:", error);
        }
      };
      fetchStudentListDropdown();
    } else if (
      searchStudentQuery == "" ||
      searchStudentQuery == null ||
      searchStudentQuery.length < 2
    ) {
      const optionsStudent = [
        {
          value: null,
          label: "Search Student",
        },
      ];
      setStudentOptions(optionsStudent);
    }
  }, [searchStudentQuery]);
  // Calculate the total number of pages

  // const totalPages = Math.ceil(totalRecords / itemsPerPage);

  useEffect(() => {
    fetchOffers();
  }, [currentPage, course, specializationId, passoutYear]);

  useEffect(() => {
    const storedCourses = localStorage.getItem("courses");
    if (storedCourses) {
      dispatch(setCourses(JSON.parse(storedCourses)));
    }
  }, [dispatch]);

  // Logic for displaying current students
  const totalPages = Math.ceil(totalRecords / itemsPerPage);
  const indexOfLastOffer = (currentPage + 1) * itemsPerPage;
  const indexOfFirstOffer = indexOfLastOffer - itemsPerPage;
  // const currentOffers = offers.slice(indexOfFirstOffer, indexOfLastOffer); // Get current offers based on the page

  const renderPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(0, currentPage - Math.floor(itemsPerPage / 2));
    const endPage = Math.min(totalPages - 1, startPage + itemsPerPage - 1);

    if (startPage > 0)
      pages.push(
        <span key="start-ellipsis" style={{ fontSize: 24 }}>
          ...
        </span>,
      );

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li className="page-item">
          <Link
            key={i}
            to="#"
            className={`page-link ${
              i === currentPage ? "bg-primary text-white" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i + 1}
          </Link>
        </li>,
      );
    }

    if (endPage < totalPages - 1)
      pages.push(
        <span key="end-ellipsis" style={{ fontSize: 24 }}>
          ...
        </span>,
      );

    return pages;
  };

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;
      const params = {
        college_id: collegeId,
        export_required: 1,
      };

      if (course !== null) {
        params.filter_by_course = course.filter_id;
      }

      if (
        specializationId !== null &&
        specializationName !== "Choose Specialization"
      ) {
        params.filter_by_specialization = specializationId;
      }

      if (passoutYear !== "Passout Year") {
        params.filter_by_passout_year = passoutYear;
      }

      if (search !== "") {
        params.search = search;
      }

      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/JobOffer/get_job_offer_list`,
        {
          params,
          headers: {
            Authorization: authToken,
          },
        },
      );

      if (response.data.csv_file_path) {
        const link = document.createElement("a");
        link.href = response.data.csv_file_path;
        link.download = "job_offer_list.csv";
        link.click();
      } else {
        toast.error("No offers found");
      }
    } catch (error) {
      console.error("Error exporting data:", error);
      toast.error("Failed to export data");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <Fragment>
        <PageTitle
          activeMenu="Offers List"
          motherMenu="Placement"
          pageContent="Offers List"
        />
        <div className="d-flex align-items-center flex-wrap search-job bg-white px-0 mb-4">
          <div className="col-xl-4 col-xxl-4 col-lg-4 col-sm-4 col-12 search-dropdown d-flex align-items-center">
            <Dropdown className="form-control border-0 style-1 h-auto">
              <Dropdown.Toggle
                as="div"
                className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
              >
                {course ? course.name : "Choose Course"}
                <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setCourse(null);
                    setSpecializationId(null);
                    setSpecializationName("Choose Specialization");
                    setCurrentPage(0);
                  }}
                >
                  Choose Course
                </Dropdown.Item>
                {courses?.map((course) => (
                  <Dropdown.Item
                    key={course.filter_id}
                    className="text-primary"
                    onClick={() => {
                      setCourse(course);
                      setCourseFilterId(course.college_course_id);
                      setSpecializationId(null);
                      setSpecializationName("Choose Specialization");
                      setCurrentPage(0);
                    }}
                  >
                    {course.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-xl-4 col-xxl-4 col-lg-4 col-sm-4 col-12 search-dropdown d-flex align-items-center">
            <Dropdown className="form-control border-0 style-1 h-auto">
              <Dropdown.Toggle
                as="div"
                className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
              >
                {specializationName}
                <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setSpecializationId(null);
                    setCurrentPage(0);
                    setSpecializationName("Choose Specialization");
                  }}
                >
                  Choose Specialization
                </Dropdown.Item>

                {specializationData && specializationData?.length > 0 ? (
                  specializationData?.map((specialization) => (
                    <Dropdown.Item
                      key={specialization.specilization_master_id}
                      className="text-primary"
                      onClick={() => {
                        setCurrentPage(0);
                        setSpecializationId(
                          specialization.specilization_master_id,
                        );
                        setSpecializationName(specialization.name);
                      }}
                    >
                      {specialization.name}
                    </Dropdown.Item>
                  ))
                ) : (
                  <Dropdown.Item
                    className="text-primary"
                    onClick={() => {
                      setSpecializationId(0);
                      setSpecializationName("All");
                      setCurrentPage(0);
                    }}
                  >
                    All
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-xl-3 col-xxl-3 col-lg-3 col-sm-4 col-12 search-dropdown d-flex align-items-center">
            <Dropdown className="form-control border-0 style-1 h-auto">
              <Dropdown.Toggle
                as="div"
                className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
              >
                {passoutYear}
                <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setCurrentPage(0);
                    setPassoutYear("Passout Year");
                  }}
                >
                  Passout Year
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setCurrentPage(0);
                    setPassoutYear(currentYear - 1);
                  }}
                >
                  {currentYear - 1}
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setCurrentPage(0);
                    setPassoutYear(currentYear);
                  }}
                >
                  {currentYear}
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setCurrentPage(0);
                    setPassoutYear(currentYear + 1);
                  }}
                >
                  {currentYear + 1}
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => {
                    setCurrentPage(0);
                    setPassoutYear(currentYear + 2);
                  }}
                >
                  {currentYear + 2}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-xl-1 col-xxl-1 col-lg-12 col-12 d-md-flex job-title-search pe-0">
            <div className="text-end w-100">
              <Button onClick={handleReset} variant="danger btn-sm">
                Reset
              </Button>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Offer List</h4>
              <div className="d-flex align-items-center justify-content-between">
                <Link
                  to="/add-offer"
                  className="btn btn-primary btn-sm mx-2"
                >
                  Add New Offer
                </Link>
                <Button
                  variant="secondary btn-sm"
                  onClick={handleExport}
                  className="me-3"
                  disabled={isExporting}
                >
                  {isExporting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Exporting...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-file-export me-2"></i>
                      Export
                    </>
                  )}
                </Button>
              </div>
            </div>
            <div className="card-body">
              <div
                className="table-responsive dataTables_wrapper"
                id="application-data"
              >
                {/* Loading indicator */}
                {isLoading ? (
                  <div className="text-center my-4">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <table
                    className="table display mb-4 dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
                    id="example5"
                  >
                    <thead>
                      <tr role="row">
                        <th className="sorting_asc">Id</th>
                        <th className="sorting_asc">Student Name</th>
                        <th className="sorting_asc">Position</th>
                        <th className="sorting_asc">Package</th>
                        <th className="sorting_asc">Joining Date</th>
                        <th className="sorting_asc">Company Name</th>
                        <th className="sorting_asc text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {offers && offers.length > 0 ? (
                        offers.map((offer, index) => (
                          <tr key={offer.job_offer_id} role="row">
                            <td>{index + 1 + currentPage * itemsPerPage}</td>{" "}
                            {/* Adjust index for pagination */}
                            <td>{offer.full_name}</td>
                            <td>{offer.position}</td>
                            <td>{offer.package}</td>
                            <td>
                              {new Date(
                                offer.joining_date,
                              ).toLocaleDateString()}
                            </td>
                            <td>{offer.company_name}</td>
                            <td
                              className="action-btn d-flex justify-content-center align-items-center wspace-no"
                              style={{ gap: 5 }}
                            >
                              <Button
                                onClick={() => history.push(`/edit-offer/${offer.job_offer_id}`)}
                                size="sm"
                                variant="primary"
                              >
                                Edit
                              </Button>
                              <Button
                                as={Link}
                                to={`/job-offer-details/${offer.job_offer_id}`}
                                size="sm"
                                variant="secondary"
                              >
                                View
                              </Button>
                              <Button
                                size="sm"
                                variant="danger"
                                onClick={() =>
                                  handleDelete({
                                    job_offer_id: offer.job_offer_id,
                                  })
                                }
                              >
                                Delete
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No offers found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}

                {/* Pagination */}

                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <div className="dataTables_info" id="example5_info">
                    Showing {indexOfFirstOffer + 1} to{" "}
                    {Math.min(indexOfLastOffer, totalRecords)} of {totalRecords}{" "}
                    entries
                  </div>
                  <ul className="pagination pagination-circle">
                    <li
                      className={`page-item page-indicator ${currentPage === 0 ? "disabled" : ""}`}
                    >
                      {" "}
                      <Link
                        className={`page-link  ${
                          currentPage === 0 ? "disabled" : ""
                        }`}
                        onClick={() => {
                          if (currentPage > 0)
                            handlePageChange(currentPage - 1);
                        }}
                      >
                        Prev
                      </Link>
                    </li>
                    {renderPageNumbers()}
                    <li
                      className={`page-item page-indicator ${
                        currentPage === totalPages - 1 ? "disabled" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className={`page-link  ${
                          currentPage === totalPages - 1 ? "disabled" : ""
                        }`}
                        onClick={() => {
                          if (currentPage < totalPages - 1)
                            handlePageChange(currentPage + 1);
                        }}
                      >
                        Next
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Fragment>
    </>
  );
};

export default OfferTable;
